import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'auth.login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'auth.email.verify',
        path: `${AUTH_PREFIX_PATH}/email/verify`,
        component: React.lazy(() => import('views/auth-views/authentication/verify-email')),
    },
    {
        key: 'auth.code.set',
        path: `${AUTH_PREFIX_PATH}/code/confirm`,
        component: React.lazy(() => import('views/auth-views/authentication/set-code')),
    },
]

export const protectedRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    {
        key: 'dashboard.stats',
        path: `${APP_PREFIX_PATH}/dashboards/stats`,
        component: React.lazy(() => import('views/app-views/dashboards/stats')),
    },
    {
        key: 'predictions.teams',
        path: `${APP_PREFIX_PATH}/predictions/teams`,
        component: React.lazy(() => import('views/app-views/predictions/teams')),
    },
    {
        key: 'predictions.fixtures',
        path: `${APP_PREFIX_PATH}/predictions/fixtures`,
        component: React.lazy(() => import('views/app-views/predictions/fixtures')),
    },
    {
        key: 'predictions.members',
        path: `${APP_PREFIX_PATH}/predictions/members`,
        component: React.lazy(() => import('views/app-views/predictions/member-predictions')),
    },
    {
        key: 'administration.access.permission',
        path: `${APP_PREFIX_PATH}/administration/access/permission`,
        component: React.lazy(() => import('views/app-views/administration/access/user-permissions')),
    },
    {
        key: 'administration.access.role',
        path: `${APP_PREFIX_PATH}/administration/access/role`,
        component: React.lazy(() => import('views/app-views/administration/access/role-permissions')),
    },
    {
        key: 'administration.user.role',
        path: `${APP_PREFIX_PATH}/administration/user/role`,
        component: React.lazy(() => import('views/app-views/administration/users/member-roles')),
    },
    {
        key: 'administration.user.member',
        path: `${APP_PREFIX_PATH}/administration/user/member`,
        component: React.lazy(() => import('views/app-views/administration/users/members')),
    },
    {
        key: 'administration.user.portal',
        path: `${APP_PREFIX_PATH}/administration/user/portal`,
        component: React.lazy(() => import('views/app-views/administration/users/portal-members')),
    },
    {
        key: 'settings.competition',
        path: `${APP_PREFIX_PATH}/settings/competitions`,
        component: React.lazy(() => import('views/app-views/settings/competitions')),
    },
    {
        key: 'settings.market',
        path: `${APP_PREFIX_PATH}/settings/markets`,
        component: React.lazy(() => import('views/app-views/settings/markets')),
    },
    {
        key: 'settings.subscription',
        path: `${APP_PREFIX_PATH}/settings/subscriptions`,
        component: React.lazy(() => import('views/app-views/settings/subscriptions')),
    },
    {
        key: 'settings.status.member',
        path: `${APP_PREFIX_PATH}/settings/statuses/member`,
        component: React.lazy(() => import('views/app-views/settings/statuses/member-statuses')),
    },
    {
        key: 'settings.status.invoice',
        path: `${APP_PREFIX_PATH}/settings/statuses/invoice`,
        component: React.lazy(() => import('views/app-views/settings/statuses/invoice-statuses')),
    },
    {
        key: 'settings.status.prediction',
        path: `${APP_PREFIX_PATH}/settings/statuses/prediction`,
        component: React.lazy(() => import('views/app-views/settings/statuses/prediction-statuses')),
    },
    {
        key: 'settings.type.notification',
        path: `${APP_PREFIX_PATH}/settings/type/notification`,
        component: React.lazy(() => import('views/app-views/settings/typologies/notification-types')),
    },
    {
        key: 'profile.account',
        path: `${APP_PREFIX_PATH}/profile`,
        component: React.lazy(() => import('views/app-views/profile/account')),
    },
    {
        key: 'profile.notification',
        path: `${APP_PREFIX_PATH}/profile/notification`,
        component: React.lazy(() => import('views/app-views/profile/account/management/components/Notifications')),
    },
    {
        key: 'profile.settings',
        path: `${APP_PREFIX_PATH}/profile/settings`,
        component: React.lazy(() => import('views/app-views/profile/account/management/components/Settings')),
    },
    {
        key: 'profile.password.change',
        path: `${APP_PREFIX_PATH}/profile/password/change`,
        component: React.lazy(() => import('views/app-views/profile/account/management/components/ChangePassword')),
    },
]